'use client'

// istanbul ignore next
const _window = typeof window !== 'undefined' ? window : undefined

export const debounce = (callback: (...args: any) => void, wait?: number) => {
  let timeoutId: number | undefined = undefined

  //@ts-ignore
  return (...args) => {
    //@ts-ignore
    _window?.clearTimeout(timeoutId)
    timeoutId = _window?.setTimeout(() => {
      callback.apply(null, args)
    }, wait)
  }
}

//copied from https://github.com/bollwyvl/es6-promise-debounce/blob/master/es6-promise-debounce.js
// biome-ignore lint/complexity/noBannedTypes: <explanation>
export const debouncePromise = (fn: Function, wait?: number, immediate?: boolean) => {
  var timer: NodeJS.Timer | null = null
  return function () {
    // @ts-ignore
    var context = this
    var args = arguments
    // @ts-ignore
    var resolve
    var promise = new Promise(function (_resolve) {
      resolve = _resolve
    }).then(function () {
      return fn.apply(context, args)
    })
    if (!!immediate && !timer) {
      // @ts-ignore
      resolve()
    }
    // istanbul ignore next
    if (timer) {
      // istanbul ignore next
      clearTimeout(timer)
    }
    timer = setTimeout(function () {
      timer = null
      if (!immediate) {
        // @ts-ignore
        resolve()
      }
    }, wait)
    return promise
  }
}
